import { GAME_ID, REDUX_ACTIONS } from 'a/pickyGoblins/data/constants';

const initialState = {
  hasSeenOnboardingPractice: false,
  hasSeenOnboardingQuest: false,
};

const gameDetailsReducer = (state = initialState, { gameId, type }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.REGISTER_ONBOARDING_QUEST_COMPLETE:
      return {
        ...state,
        hasSeenOnboardingQuest: true,
      };

    case REDUX_ACTIONS.REGISTER_ONBOARDING_PRACTICE_COMPLETE:
      return {
        ...state,
        hasSeenOnboardingPractice: true,
      };

    default:
      return state;
  }
};

export default gameDetailsReducer;
